export const guestCardTypes = {
    loading: "LOADING_GUESTCARD",
    delete: "DELETE_GUESTCARD",
    loadedOne: "LOADED_GUESTCARD",
    loadedMultiple: "LOADED_GUESTCARDS",
    success: "SUCCESS_GUESTCARD",
    restore: "RESTORE_GUESTCARD",
    hardDelete: "HARDDELETE_GUESTCARD",
};
